"use client";
import { createContext, useEffect, useState, ReactNode } from "react";
import axios from "../config/axios";


  

// Tipo do usuário
export interface User {
  name: string;
  email: string;
  phone: string;
  role: string;
  _id: string;
  addresses: {
    street: string;
    city: string;
    email: string;
    company_name: string;
    province: string;
    country: string;
    postal_code: string;
    phone: string;
    _id: string;
  }[];
}

// Tipo do contexto
interface AuthContextType {
  user: User | null;
  setUser: (user: User | null) => void;
}

// Criando o contexto corretamente
export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null);

  // Método para limpar dados de autenticação
  const clearAuth = () => {
    // Limpar token do localStorage
    if (typeof window !== 'undefined') {
      localStorage.removeItem('authToken');
    }
    setUser(null);
  };

  // Método para definir usuário que também lida com o logout
  const setUserWithToken = (newUser: User | null) => {
    if (!newUser) {
      clearAuth();
    } else {
      setUser(newUser);
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        // Verificar se há um token armazenado
        const token = typeof window !== 'undefined' ? localStorage.getItem('authToken') : null;
        
        // Se não houver token, não tente buscar o perfil
        if (!token) {
          setUser(null);
          return;
        }
        
        const { data } = await axios.get("/auth/profile");
        setUser(data);
      } catch (error) {
        console.log("Erro ao buscar perfil:", error);
        clearAuth(); // Limpar dados em caso de erro
      }
    };
    
    // Buscar o perfil do usuário inicialmente
    fetchUser();
    
    // Configurar verificação periódica para manter a sessão
    const sessionCheckInterval = setInterval(() => {
      const token = typeof window !== 'undefined' ? localStorage.getItem('authToken') : null;
      if (token) {
        fetchUser();
      }
    }, 10 * 60 * 1000); // Verificar a cada 10 minutos
    
    // Limpar o intervalo quando o componente for desmontado
    return () => clearInterval(sessionCheckInterval);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser: setUserWithToken }}>
      {children}
    </AuthContext.Provider>
  );
}
